/*=========================================================================================
  File Name: actions.js
  Namespace: videos
  Description: Vuex Store - Video actions
==========================================================================================*/
import {
  getVideo,
  createVideo,
  editVideo,
  listVideos
} from '@/services/videos.service'
import {
  listFiles
} from '@/services/files.services.js'
import {
  adaptVideoToStore
} from '@/services/adapters/videoAdapter.js'
import {
  shortenUUIDs
} from '@/utils/utils'

const actions = {
  async getVideoAction({
    commit
  }, {
    videoId
  }) {
    const response = await getVideo({
      videoId
    })
    if (response) {
      commit('STORE_CURRENT_VIDEO', response)
    }
    return response
  },
  async getAllVideos({
    commit,
    rootGetters
  }, params = {}) {
    if (params.ids && params.ids.length > 20) {
      params.ids = shortenUUIDs(params.ids)
    }
    params.company = rootGetters['app/getSelectedCompanyName']
    const response = await listVideos(params)
    if (response) {
      commit('STORE_LIST_VIDEOS', response)
    }
    return response
  },
  async saveVideoToApi({
    commit,
    getters,
    rootGetters
  }) {
    let response
    if (getters.getCurrentVideo.id) {
      // we need to delete S3 source to avoid problems.
      response = await editVideo({
        ...getters.getCurrentVideo,
        files: getters.getCurrentVideoFiles.map(f => f.id),
        source: null,
        videoId: getters.getCurrentVideo.id,
        company: rootGetters['app/getSelectedCompanyName']
      })
    } else {
      response = await createVideo({
        ...getters.getCurrentVideo,
        files: getters.getCurrentVideoFiles.map(f => f.id),
        company: rootGetters['app/getSelectedCompanyName']
      })
    }
    commit('STORE_CURRENT_VIDEO', response)
    return response
  },
  saveVideoToEdit({
    commit
  }, video) {
    commit('STORE_CURRENT_VIDEO', adaptVideoToStore({
      data: video
    }))
  },
  saveVideoToEntries({
    commit
  }, video) {
    commit('STORE_VIDEO_TO_LIST', {
      [video.id]: video
    })
  },
  resetCurrentVideo({
    commit
  }) {
    commit('RESET_CURRENT_VIDEO')
  },
  async getAllVideoFiles({ commit }, files) {
    const response = await listFiles({
      ids: files
    })
    commit('STORE_CURRENT_VIDEO_FILES', response.results)
  },
  async searchVideos({
    rootGetters
  }, params = {}) {
    if (params.ids && params.ids.length > 20) {
      params.ids = shortenUUIDs(params.ids)
    }
    params.company = rootGetters['app/getSelectedCompanyName']
    const response = await listVideos(params)
    return response
  },
}

export default actions
